import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import ColorTextField from './UI/ColorTextField';
import NumberField from './UI/NumberField';

class CanvasModifier extends React.Component {
  state = {
    width: null,
    height: null,
    backgroundColor: null,
    inputIsValid: {
      width: true,
      height: true,
      backgroundColor: true,
    },
  };

  handleWidthChange = (width, isValid) => {
    this.setState(prevState => ({
      width,
      inputIsValid: { ...prevState.inputIsValid, width: isValid },
    }));
  };

  handleHeightChange = (height, isValid) => {
    this.setState(prevState => ({
      height,
      inputIsValid: { ...prevState.inputIsValid, height: isValid },
    }));
  };

  handleBackgroundColorChange = (backgroundColor, isValid) => {
    this.setState(prevState => ({
      backgroundColor,
      inputIsValid: { ...prevState.inputIsValid, backgroundColor: isValid },
    }));
  };

  canSubmit = () => Object.values(this.state.inputIsValid).every(Boolean);

  handleClick = () => {
    this.props.onChange(
      this.state.width != null ? this.state.width : this.props.width,
      this.state.height != null ? this.state.height : this.props.height,
      this.state.backgroundColor != null ? this.state.backgroundColor : this.props.backgroundColor
    );
  };

  render() {
    return (
      <Stack useFlexGap sx={{ width: '100%' }} spacing={1} justifyContent="flex-end" alignItems="flex-start">
        <Box sx={{ maxWidth: '100%' }}>
          <Stack useFlexGap sx={{ width: '100%' }} alignItems="flex-start">
            <Box sx={{ maxWidth: '100%' }}>
              <NumberField
                label="Width"
                onChange={this.handleWidthChange}
                value={this.state.width !== null ? this.state.width : this.props.width}
                allowPositive
              />
            </Box>
            <Box sx={{ maxWidth: '100%' }}>
              <NumberField
                label="Height"
                onChange={this.handleHeightChange}
                value={this.state.height !== null ? this.state.height : this.props.height}
                allowPositive
              />
            </Box>
          </Stack>
        </Box>
        <Box sx={{ maxWidth: '100%' }}>
          <ColorTextField
            label="Background Color"
            onColorChange={this.handleBackgroundColorChange}
            value={
              this.state.backgroundColor !== null
                ? this.state.backgroundColor
                : this.props.backgroundColor
            }
          />
        </Box>
        <Box sx={{ maxWidth: '100%' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleClick}
            disabled={!this.canSubmit()}
          >
            Submit
          </Button>
        </Box>
      </Stack>
    );
  }
}

CanvasModifier.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  backgroundColor: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
CanvasModifier.defaultProps = {
  width: 0,
  height: 0,
  backgroundColor: '',
  onChange() {},
};

export default CanvasModifier;
